<template>
  <ProSpaceModal
    v-model="localModelValue"
    :title="`${masterName} — ${$t('changeHistory')}`"
    icon="history"
    width="1200"
    without-padding
    :content-style="{ height: '80vh' }"
    @close="closeModal"
    :cancelTxt="$t('closeTxt')"
    applyTxt=""
  >
    <template v-slot:default>
      <ProSpaceGeoLayout>
        <template #center>
          <ProSpaceRadioButtonSecondary
            v-model="activeTab"
            :tabs="tabs"
            @update:modelValue="tabChanged"
            @update:tabs="tabsUpdated"
          >
            <template v-for="t in tabs" :key="t.value" v-slot:[t.value]>
              <component
                :class="t.modelName"
                :is="`${t.modelName}History`"
                :ref="`${t.value}-grid`"
                :historyService="historyService"
                :historyCustomServices="customServices"
                :defaultFilter="defaultFilter"
                :name="`grid-${t.modelName}`"
                @selectedHandler="selectedHandler($event, `${t.value}-grid`)"
                @openFromReference="openFromReference"
              >
              </component>
            </template>
          </ProSpaceRadioButtonSecondary>
        </template>
        <template #right>
          <HistoryPanel
            v-if="spShow"
            ref="right-panel"
            :historyService="historyService"
            :record="selectedModel"
            :getActualName="$refs[`${activeTab.value}-grid`].getActualName"
            :getActualId="$refs[`${activeTab.value}-grid`].getActualId"
            :getActualStatus="$refs[`${activeTab.value}-grid`].getActualStatus"
            @showReferenceChanges="showReferenceChanges"
          />
        </template>
      </ProSpaceGeoLayout>
    </template>
  </ProSpaceModal>
</template>
<script>
import {
  ProSpaceModal,
  ProSpaceMainGrid,
  ProSpaceGeoLayout,
  ProSpaceRadioButtonSecondary,
} from "@prospace/prospace-components-library";
import { HistoryService } from "../../services/HistoryService";
import { OperationService } from "../../services/OperationService";
import HistoryPanel from "./HistoryPanel";
/*ImportHistoryGridsStart*/
import HSRApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/HSRs/components/HSRApiModelHistory.vue";
import TDMApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/TDMs/components/TDMApiModelHistory.vue";
import KADLApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/KADLs/components/KADLApiModelHistory.vue";
import AgencyApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Agencies/components/AgencyApiModelHistory.vue";
import NetworkApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Networks/components/NetworkApiModelHistory.vue";
import ExternalFormatApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/ExternalFormats/components/ExternalFormatApiModelHistory.vue";
import OutletTypeApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/OutletTypes/components/OutletTypeApiModelHistory.vue";
import ChannelApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Channels/components/ChannelApiModelHistory.vue";
import ClusterApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Clusters/components/ClusterApiModelHistory.vue";
import NARKAApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/NARKAs/components/NARKAApiModelHistory.vue";
import SIPChannelApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/SIPChannels/components/SIPChannelApiModelHistory.vue";
import KASApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/KASs/components/KASApiModelHistory.vue";
import MerchandiserApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Merchandisers/components/MerchandiserApiModelHistory.vue";
import RouteCodeApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/RouteCodes/components/RouteCodeApiModelHistory.vue";
import AddressProgramOrderApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/AddressProgramOrders/components/AddressProgramOrderApiModelHistory.vue";
import DocumentApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Documents/components/DocumentApiModelHistory.vue";
import MarsPeriodApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/MarsPeriods/components/MarsPeriodApiModelHistory.vue";
import OrderApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Orders/components/OrderApiModelHistory.vue";
import RSMApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/RSMs/components/RSMApiModelHistory.vue";
import TDMApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/TDMs/components/TDMApiModelHistory.vue";
import KAEApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/KAEs/components/KAEApiModelHistory.vue";
import AgencyApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Agencies/components/AgencyApiModelHistory.vue";
import NetworkApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Networks/components/NetworkApiModelHistory.vue";
import ExternalFormatApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/ExternalFormats/components/ExternalFormatApiModelHistory.vue";
import OutletTypeApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/OutletTypes/components/OutletTypeApiModelHistory.vue";
import ChannelApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Channels/components/ChannelApiModelHistory.vue";
import ClusterApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Clusters/components/ClusterApiModelHistory.vue";
import NARKAApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/NARKAs/components/NARKAApiModelHistory.vue";
import SIPChannelApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/SIPChannels/components/SIPChannelApiModelHistory.vue";
import KASApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/KASs/components/KASApiModelHistory.vue";
import MerchandiserApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Merchandisers/components/MerchandiserApiModelHistory.vue";
import RouteCodeApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/RouteCodes/components/RouteCodeApiModelHistory.vue";
import AddressProgramOrderArchivedApiModelHistory from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/AddressProgramOrders/components/AddressProgramOrderApiModelHistory.vue";
import DocumentApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Documents/components/DocumentApiModelHistory.vue";
import MarsPeriodApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/MarsPeriods/components/MarsPeriodApiModelHistory.vue";
import OrderApiModelHistoryArchived from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Orders/components/OrderApiModelHistory.vue";
import BaseTypeApiModelHistory from "../../../../Services/BaseType/BaseTypeService.Frontend/views/BaseTypes/components/BaseTypeApiModelHistory.vue";
import SystemDirectoryApiModelHistory from "../../../../Services/BaseType/BaseTypeService.Frontend/views/SystemDirectories/components/SystemDirectoryApiModelHistory.vue";
import SecurityUserApiModelHistory from "../../../../Services/SecurityAdmin/ProSpace.SecurityAdmin.Frontend/views/Users/components/SecurityUserApiModelHistory.vue";
import SecurityUserRoleApiModelHistory from "../../../../Services/SecurityAdmin/ProSpace.SecurityAdmin.Frontend/views/Users/components/SecurityUserRoleApiModelHistory.vue";
import SecurityRoleApiModelHistory from "../../../../Services/SecurityAdmin/ProSpace.SecurityAdmin.Frontend/views/Roles/components/SecurityRoleApiModelHistory.vue";
import SecurityUseCaseApiModelHistory from "../../../../Services/SecurityAdmin/ProSpace.SecurityAdmin.Frontend/views/UseCases/components/SecurityUseCaseApiModelHistory.vue";
import SecurityUseCaseClaimApiModelHistory from "../../../../Services/SecurityAdmin/ProSpace.SecurityAdmin.Frontend/views/UseCases/components/SecurityUseCaseClaimApiModelHistory.vue";
import MenuItemApiModelHistory from "../../../../Services/SecurityAdmin/ProSpace.SecurityAdmin.Frontend/views/MenuItems/components/MenuItemApiModelHistory.vue";
import NotificationApiModelHistory from "../../../../Services/Notification/ProSpace.Notification.Frontend/views/Notification/components/NotificationApiModelHistory.vue";
import NotificationLogApiModelHistory from "../../../../Services/Notification/ProSpace.Notification.Frontend/views/NotificationLogs/components/NotificationLogApiModelHistory.vue";
import JobTriggerConfigurationApiModelHistory from "../../../../Services/Scheduler/ProSpace.Scheduler.Frontend/views/SystemTasks/components/JobTriggerConfigurationApiModelHistory.vue";
import TaskQueueItemApiModelHistory from "../../../../Services/Scheduler/ProSpace.Scheduler.Frontend/views/UserTasks/components/TaskQueueItemApiModelHistory.vue";
import WorkflowSettingApiModelHistory from "../../../../Services/Workflow/ProSpace.Workflow.Frontend/views/workflow/components/WorkflowSettingApiModelHistory.vue";
import WorkflowSettingItemApiModelHistory from "../../../../Services/Workflow/ProSpace.Workflow.Frontend/views/workflow/components/WorkflowSettingItemApiModelHistory.vue";
import AreaApiModelHistory from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Areas/components/AreaApiModelHistory.vue";
import CompetenceDirectoryApiModelHistory from "../../../../Services/Competence/CompetenceService.Frontend/views/CompetenceDirectories/components/CompetenceDirectoryApiModelHistory.vue";
import CompetenceApiModelHistory from "../../../../Services/Competence/CompetenceService.Frontend/views/Competences/components/CompetenceApiModelHistory.vue";
import CompetenceTaskApiModelHistory from "../../../../Services/Competence/CompetenceService.Frontend/views/CompetenceTasks/components/CompetenceTaskApiModelHistory.vue";
import CompetenceTaskAttachmentApiModelHistory from "../../../../Services/Competence/CompetenceService.Frontend/views/CompetenceTasks/components/CompetenceTaskAttachmentApiModelHistory.vue";

/*ImportHistoryGridsEnd*/
import { mapGetters } from "vuex";
export default {
  name: "ProSpaceHistoryModal",
  components: {
    ProSpaceModal,
    ProSpaceMainGrid,
    ProSpaceGeoLayout,
    HistoryPanel,
    ProSpaceRadioButtonSecondary,
    /*ComponentsHistoryGridsStart*/
    HSRApiModelHistory,
    TDMApiModelHistory,
    KADLApiModelHistory,
    AgencyApiModelHistory,
    NetworkApiModelHistory,
    ExternalFormatApiModelHistory,
    OutletTypeApiModelHistory,
    ChannelApiModelHistory,
    ClusterApiModelHistory,
    NARKAApiModelHistory,
    SIPChannelApiModelHistory,
    KASApiModelHistory,
    MerchandiserApiModelHistory,
    RouteCodeApiModelHistory,
    AddressProgramOrderApiModelHistory,
    DocumentApiModelHistory,
    MarsPeriodApiModelHistory,
    OrderApiModelHistory,
    RSMApiModelHistoryArchived,
    TDMApiModelHistoryArchived,
    KAEApiModelHistoryArchived,
    AgencyApiModelHistoryArchived,
    NetworkApiModelHistoryArchived,
    ExternalFormatApiModelHistoryArchived,
    OutletTypeApiModelHistoryArchived,
    ChannelApiModelHistoryArchived,
    ClusterApiModelHistoryArchived,
    NARKAApiModelHistoryArchived,
    SIPChannelApiModelHistoryArchived,
    KASApiModelHistoryArchived,
    MerchandiserApiModelHistoryArchived,
    RouteCodeApiModelHistoryArchived,
    AddressProgramOrderArchivedApiModelHistory,
    DocumentApiModelHistoryArchived,
    MarsPeriodApiModelHistoryArchived,
    OrderApiModelHistoryArchived,
    BaseTypeApiModelHistory,
    SystemDirectoryApiModelHistory,
    SecurityUserApiModelHistory,
    SecurityUserRoleApiModelHistory,
    SecurityRoleApiModelHistory,
    SecurityUseCaseApiModelHistory,
    SecurityUseCaseClaimApiModelHistory,
    MenuItemApiModelHistory,
    NotificationApiModelHistory,
    NotificationLogApiModelHistory,
    JobTriggerConfigurationApiModelHistory,
    TaskQueueItemApiModelHistory,
    WorkflowSettingApiModelHistory,
    WorkflowSettingItemApiModelHistory,
    AreaApiModelHistory,
    CompetenceDirectoryApiModelHistory,
    CompetenceApiModelHistory,
    CompetenceTaskApiModelHistory,
    CompetenceTaskAttachmentApiModelHistory
    /*ComponentsHistoryGridsEnd*/
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    modelName: {
      type: String,
      required: true,
    },
  },
  watch: {
    modelValue(val) {
      if (!val) {
        this.selectedModel = {};
        this.tabs = [
          {
            value: "tab-1",
            label: this.$t('historyMain'),
            modelName: this.modelName,
            isActive: true,
            masterId: null,
          },
        ];
      } else {
        this.historyService.modelName = this.modelName;
        this.historyService.loadModelInfo();
      }
      this.$emit("update:modelValue", val);
    },
  },
  data() {
    return {
      // Grid Panel
      selectedModel: {},
      spHide: false,
      panelModel: {},
      panelModels: [],

      historyService: new HistoryService(),
      //InlinePanel
      masterName: "",
      activeTabName: "tab-1",
      tabs: [
        {
          value: "tab-1",
          label: this.$t('historyMain'),
          modelName: this.modelName,
          masterId: null,
        },
      ],
    };
  },
  methods: {
    openFromReference(record, fieldName) {
      const conf = this.referenceFieldConfs[fieldName];
      let keyField = Object.keys(this.referenceFieldConfs).find(
        (key) =>
          this.referenceFieldConfs[key].modelName === conf.modelName &&
          this.referenceFieldConfs[key].isKey === true
      );
      let tab = this.tabs.find(
        (t) =>
          t.masterId === record.actualModel[keyField] &&
          t.modelName === conf.modelName
      );
      if (tab) return;

      this.tabs.push({
        value: `tab-${this.tabs.length + 1}`,
        label: this.$t(`${conf.modelName}Changes`),
        modelName: conf.modelName,
        isReference: false,
        masterId: record.actualModel[keyField],
        deleted: true,
      });
    },
    showReferenceChanges(modelName, groupId) {
      let tab = this.tabs.find(
        (t) => t.groupId === groupId && t.modelName === modelName
      );
      if (tab) return;

      this.tabs.push({
        value: `tab-${this.tabs.length + 1}`,
        label: this.$t(`${modelName}Changes`),
        modelName: modelName,
        groupId: groupId,
        isReference: true,
        deleted: true,
      });
    },
    tabChanged(tabInfo) {
      this.activeTabName = tabInfo.value;
      this.selectedModel = {};
      if (tabInfo.modelName) this.historyService.modelName = tabInfo.modelName;
      this.historyService.loadModelInfo();
    },
    tabsUpdated(tabs) {
      this.tabs = tabs;
    },
    selectedHandler(data, ref) {
      const grid = this.$refs[ref];
      if (grid?.getSelectedModel) {
        this.selectedModel = grid.getSelectedModel();
      } else {
        this.selectedModel = data ?? {};
      }
    },
    closeModal() {
      this.$emit("update:modelValue", false);
    },
    getColumnValue(config, record) {
      if (config.value && typeof config.value === "function")
        return config.value(record);

      return record[config.field];
    },
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
    }),
    customServices() {
      return [
        {
          type: "checkboxes",
          service: new OperationService(),
          getMethod: "get",
          model: "operationType",
          label: this.$t("operation"),
          optionValue: "operationType",
          optionLabel: "text",
          selected: {},
        },
        {
          type: "dates-range-time",
          model: "editDate",
          label: this.$t("editDate"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
      ];
    },
    referenceFieldConfs() {
      return this.historyService.referenceFieldConfs();
    },
    localModelValue: {
      get() {
        return this.modelValue;
      },
      set(newVal) {
        this.$emit("update:modelValue", newVal);
      },
    },
    defaultFilter() {
      let filter = {};
      if (this.activeTab.isReference) {
        filter["GroupIds"] = {
          any: [{ any: this.activeTab.groupId }],
        };
      } else {
        filter["ActualModel/Id"] = { and: [this.activeTab.masterId] };
      }
      return filter;
    },
    spShow() {
      return !!this.selectedModel && Object.keys(this.selectedModel).length > 0;
    },
    activeTab() {
      return this.tabs.find((t) => t.value === this.activeTabName);
    },
  },
};
</script>
